import React from 'react';
import { clsx } from 'clsx';
import { Link, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { routeNames, routes } from 'routes';

import LogoWithText from 'assets/img/logo.png';
import Logo from 'assets/img/one.svg';

import styles from './styles.module.scss';
import { socials } from 'helpers/socials';
import { useGetAccountInfo } from '@multiversx/sdk-dapp/hooks';


export const Navbar = () => {
  const location = useLocation();
  const { address: userAddress } = useGetAccountInfo();
  
  return (
    <div className={clsx(styles.navbar, 'd-flex flex-column')}>
      <div className={clsx(styles.menu, 'd-flex justify-content-start')}>
        {
          routes.map((route, index) => 
            !route.isSubMenu && !(!userAddress && route.path == routeNames.dashboard) && 
            <Link className={clsx(styles.menuItem, (location.pathname === route.path) && styles.active)} to={route.path} key={index}>
              <div className='d-flex justify-content-center align-items-center' style={{ width: 24, height: 24, position: 'relative' }}>
                <img style={{ width: '100%' }} src={location.pathname === route.path ? route.active_icon : route.icon} />
              </div>
              <div>
                {route.title}
              </div>
            </Link>
          )
        }
      </div>
      <div className='flex-grow-1' />
      <div className={clsx(styles.socials, 'd-flex justify-content-around')}>
        {
          socials.map((social, index) => 
            <a key={index} href={social.link} target='_blank' rel='noreferrer' className={styles.icon}>
              <span className={social.icon} />
            </a>
          )
        }
      </div>
    </div>
  );
};
